// extracted by mini-css-extract-plugin
export default {"statImg":"StatImg_statImg__gnD-x","statImg__img":"StatImg_statImg__img__IcyNw"};